(() => {
  let _activeBtn = null, _focusLocked = false, _lockTimer = null;
  let _isProgrammaticChange = false, _genderTimer = null, _sortTimer = null;

  const clearSearchanizeActiveElement = () => {
    const searchanizeElement = document.querySelector('searchanize-products');
    if (searchanizeElement?.settings) searchanizeElement.settings.activeElementId = null;
  };

  const startFocusLock = (targetButton) => {
    _activeBtn = targetButton;
    _focusLocked = true;
    clearTimeout(_lockTimer);
    _lockTimer = setTimeout(stopFocusLock, 3000);
  };

  const stopFocusLock = () => {
    _focusLocked = false;
    _activeBtn = null;
    clearTimeout(_lockTimer);
  };

  document.addEventListener('focusin', (event) => {
    if (_focusLocked && _activeBtn && event.target !== _activeBtn) {
      event.stopImmediatePropagation();
      _activeBtn.focus({ preventScroll: true });
    }
  }, true);

  const releaseLock = () => { if (_focusLocked) stopFocusLock(); };
  document.addEventListener('keydown', releaseLock, true);
  document.addEventListener('mousedown', releaseLock, true);

  const initCategoryFilters = () => {
    const setButtonActiveState = (button, isActive) => {
      if (!button) return;
      button.setAttribute('aria-pressed', String(isActive));
      button.classList.toggle('active', Boolean(isActive));
      button.classList.toggle('frag-cat-btn-active', Boolean(isActive));
      button.classList.toggle('frag-cat-btn-inactive', !isActive);
    };

    document.addEventListener('click', (event) => {
      const checkboxElement = event.target;
      if (checkboxElement?.type === 'checkbox' && checkboxElement.closest('searchanize-products')) {
        const gender = applyGenderFilter(checkboxElement);
        if (gender) {
          const genderButtonMap = { men: 'him', women: 'her', unisex: 'his & hers' };
          const matchedCategoryButton = Array.from(document.querySelectorAll('.frag-cat-item-btn')).find(categoryButton => {
            const categoryTitle = categoryButton.getAttribute('data-category-title');
            return categoryTitle && categoryTitle.toLowerCase().includes(genderButtonMap[gender]);
          });
          setButtonActiveState(matchedCategoryButton, checkboxElement.checked);
        }
        return;
      }

      const sortItem = event.target.closest('[data-sortby-list] li');
      if (sortItem && !_isProgrammaticChange) {
        const sortValue = sortItem.getAttribute('data-value');
        const sortText = (sortItem.getAttribute('data-text') || sortItem.textContent || '').toLowerCase();
        const isBestseller = sortValue?.includes('sales_amount') && (sortText.includes('best') || sortText.includes('trending'));
        const trendingCategoryButton = Array.from(document.querySelectorAll('.frag-cat-item-btn')).find(categoryButton => {
          const categoryTitle = categoryButton.getAttribute('data-category-title');
          return categoryTitle && (categoryTitle.toLowerCase().includes('best') || categoryTitle.toLowerCase().includes('trending'));
        });
        setButtonActiveState(trendingCategoryButton, isBestseller);
      }

      const clickedCategoryButton = event.target.closest('.frag-cat-item-btn');
      if (!clickedCategoryButton) return;

      const isActive = clickedCategoryButton.getAttribute('aria-pressed') === 'true';
      if (isActive) return;

      document.querySelectorAll('.frag-cat-item-btn').forEach(categoryButton => {
        if (categoryButton === clickedCategoryButton) return;
        setButtonActiveState(categoryButton, false);
      });

      setButtonActiveState(clickedCategoryButton, true);

      if (!_isProgrammaticChange) startFocusLock(clickedCategoryButton);

      const categoryTitle = (clickedCategoryButton.getAttribute('data-category-title') || '').toLowerCase().trim();
      clearTimeout(_genderTimer);
      clearTimeout(_sortTimer);

      if (categoryTitle.includes('him') || categoryTitle === 'men') {
        applyGenderFilter('men', !isActive);
      } else if (categoryTitle.includes('his & her') || categoryTitle.includes('unisex')) {
        applyGenderFilter('unisex', !isActive);
      } else if (categoryTitle.includes('her') || categoryTitle === 'women') {
        applyGenderFilter('women', !isActive);
      } else if (categoryTitle.includes('best') || categoryTitle.includes('trending')) {
        if (isActive) {
          applyDefaultSort();
        } else {
          applyBestsellerSort();
        }
      }
    });

    function applyGenderFilter(genderValue, isChecked, retryCount = 0) {
      const getCheckboxGender = (checkboxInput) => {
        const label = document.getElementById(checkboxInput.getAttribute('aria-labelledby')) || document.querySelector(`label[for="${checkboxInput.id}"]`);
        const text = (checkboxInput.value + ' ' + (label ? label.textContent : '')).toLowerCase();
        if (/\b(unisex|both|universal|his\s*(?:&\s*|and\s*)hers?)\b/.test(text)) return 'unisex';
        if (/\b(women|woman|female|her|hers)\b/.test(text)) return 'women';
        if (/\b(men|man|male|him|his)\b/.test(text)) return 'men';
        return null;
      };

      if (genderValue && typeof genderValue === 'object') return getCheckboxGender(genderValue);

      const checkboxes = Array.from(document.querySelectorAll('searchanize-products input[type="checkbox"]'));
      const targetCheckboxes = checkboxes.filter(checkboxInput => getCheckboxGender(checkboxInput) === genderValue.toLowerCase());
      
      if (targetCheckboxes.length > 0) {
        let hasStateChanged = false;
        if (isChecked) {
          checkboxes.forEach(cb => {
            if (getCheckboxGender(cb) && !targetCheckboxes.includes(cb) && cb.checked) {
              cb.checked = false;
              hasStateChanged = true;
            }
          });
        }
        targetCheckboxes.forEach(checkboxElement => {
          if (checkboxElement.checked !== isChecked) {
            checkboxElement.checked = isChecked;
            hasStateChanged = true;
          }
        });
        if (hasStateChanged && !_isProgrammaticChange) {
          targetCheckboxes[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
        clearSearchanizeActiveElement();
      } else if (retryCount < 10) {
        clearTimeout(_genderTimer);
        _genderTimer = setTimeout(() => applyGenderFilter(genderValue, isChecked, retryCount + 1), 300);
      }
    }

    function applyBestsellerSort(retryCount = 0) {
      const sortItems = Array.from(document.querySelectorAll('[data-sortby-list] li'));
      const bestsellerItems = sortItems.filter(item => {
        const sortValue = item.getAttribute('data-value');
        const sortText = (item.getAttribute('data-text') || item.textContent || '').toLowerCase();
        return sortValue?.includes('sales_amount') && (sortText.includes('best') || sortText.includes('trending'));
      });
      
      if (bestsellerItems.length > 0) {
        bestsellerItems.forEach(item => {
          item.setAttribute('aria-selected', 'true');
          item.classList.add('active');
        });
        document.querySelectorAll('[data-sortby] strong.label-text, [data-sortby] .label-text')
          .forEach(label => label.textContent = 'Bestselling');
        _isProgrammaticChange = true;
        bestsellerItems[0].click();
        _isProgrammaticChange = false;
        clearSearchanizeActiveElement();
      } else if (retryCount < 10) {
        clearTimeout(_sortTimer);
        _sortTimer = setTimeout(() => applyBestsellerSort(retryCount + 1), 300);
      }
    }

    function applyDefaultSort() {
      const sortItems = Array.from(document.querySelectorAll('[data-sortby-list] li'));
      const defaultItems = sortItems.filter(item => {
        const manualSortSpan = item.querySelector('span[data-href="manual"]');
        const sortText = (item.getAttribute('data-text') || item.textContent || '').toLowerCase();
        return manualSortSpan || sortText.includes('default') || sortText.includes('relevance');
      });
      
      if (defaultItems.length > 0) {
        const firstItem = defaultItems[0];
        if (!firstItem.classList.contains('active')) {
          firstItem.setAttribute('aria-selected', 'true');
          firstItem.classList.add('active');

          const sortLabels = document.querySelectorAll('[data-sortby] strong.label-text, [data-sortby] .label-text');
          sortLabels.forEach(label => {
            label.textContent = 'Relevance (Default)';
          });

          firstItem.click();
          clearSearchanizeActiveElement();
        }
      } else {
        setTimeout(applyDefaultSort, 300);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryFilters);
  } else {
    initCategoryFilters();
  }
})();